import { Configuration, CustomElementFactory } from "duice";
import { ElementRegistry } from "duice";
import { FilesElement } from "./FilesElement";
/**
 * File Element Factory
 */
export class FilesElementFactory extends CustomElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    doCreateElement(htmlElement, bindData, context) {
        return new FilesElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register
    ElementRegistry.register(`${Configuration.getNamespace()}-files`, new FilesElementFactory());
})();
//# sourceMappingURL=FilesElementFactory.js.map